import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import DetailPage from '../../containers/expertise/DetailPage';
import { maintenanceIntegrityManagement, oilGasHero, pipelineTransmissionSystemsServices } from '../../images/expertise/oil-gas';

const OilGas: NextPage = () => {
  return (
    <>
      <Header
        title="Oil & Gas"
        description="We deliver end-to-end oil and gas pipeline solutions, emphasizing secure and efficient energy transportation through innovative construction and maintenance practices."
        image={oilGasHero}
      />
      <DetailPage
        listBlocks={[
          {
            bgImage: pipelineTransmissionSystemsServices,
            id: 'oilGas',
            hasListItems: true,
            title: 'Pipeline Transmission Systems Services',
            listItems: [
              {
                boldText: 'High-Capacity Transmission Systems (Up to 48" OD Pipe):',
                text:
                  'We specialize in designing and constructing pipelines built for large-scale oil and natural gas transmission, ensuring optimal performance',
              },
              {
                boldText: 'Precision Trenching and Excavation:',
                text:
                  'Utilizing advanced excavation techniques, we adapt to various terrains to create efficient and reliable trenching solutions',
              },
              {
                boldText: 'River Crossings and HDD (Horizontal Directional Drilling):',
                text:
                  'Our environmentally conscious approaches include safe drilling and installation methods to manage river and road crossings with minimal impact',
              },
              {
                boldText: 'Mainline and Cross-Country Pipeline Construction:',
                text:
                  'Comprehensive pipeline installation projects designed to meet the highest standards of safety and efficiency across vast landscapes',
              },
              {
                boldText: 'Pipeline Loops and Laterals:',
                text: 'Enhancing network capacity through expertly constructed loops and lateral connections',
              },
              {
                boldText: 'Hydrostatic Testing & Drying Services:',
                text: 'Conducting thorough testing to guarantee pipeline strength, durability, and regulatory compliance',
              },
              {
                boldText: 'Meter and Pump Station Solutions:',
                text: 'Turnkey construction and installation of stations that ensure precise measurement and fluid movement',
              },
            ],
          },
          {
            bgImage: maintenanceIntegrityManagement,
            title: 'Maintenance & Integrity Management',
            id: 'maintenanceIntegrityManagement',
            hasListItems: true,
            listItems: [
              {
                boldText: 'Preventive Maintenance Programs:',
                text:
                  'Implementing robust maintenance strategies to maintain pipeline functionality and prevent service interruptions',
              },
              {
                boldText: 'Integrity Assurance Testing:',
                text: 'Advanced testing methodologies to ensure ongoing compliance with safety and performance standards',
              },
              {
                boldText: 'Emergency Response Services:',
                text:
                  'Swift mobilization and expert response teams ready to address urgent pipeline concerns and minimize downtime',
              },
            ],
          },
        ]}
      />
    </>
  );
};

export default OilGas;
